<template>
  <div class="inscricao-page">
    <div class="inscricao-card card">
      <header class="inscricao-header">
        <img src="../assets/logo_igreja.png" alt="El Shaday" class="brand" />
        <h1>Inscricao no Encontro</h1>
        <p class="subtitle">Preencha seus dados para participar.</p>
      </header>

      <div v-if="state === 'loading'" class="state-block">
        <div class="loader" />
        <p>Carregando...</p>
      </div>

      <div v-else-if="state === 'fechada'" class="state-block">
        <div class="state-icon">🔒</div>
        <h2 class="state-title">Inscricoes encerradas</h2>
        <p class="state-msg">{{ status?.mensagem || 'Inscricoes encerradas.' }}</p>
        <p v-if="fechaEmFormatado" class="state-date">Encerrou em: <strong>{{ fechaEmFormatado }}</strong></p>
        <p class="contato-hint">Tem duvidas? Fale com a coordenacao da igreja.</p>
      </div>

      <div v-else-if="state === 'success'" class="state-block">
        <div class="state-icon success">✅</div>
        <h2 class="state-title">Inscricao registrada!</h2>
        <p class="state-msg">A coordenacao vai te enviar mais informacoes em breve.</p>
        <a href="https://naelshaday.com.br" class="btn-secondary back-btn">Ir para o site da igreja</a>
      </div>

      <template v-else>
        <InscricaoForm
          :submitting="submitting"
          :serverError="serverError"
          @submitted="onSubmit"
        />
      </template>
    </div>

    <footer class="inscricao-footer">
      <small>Igreja El Shaday · Encontro</small>
    </footer>
  </div>
</template>

<script>
import { getInscricaoInfo, submitInscricao } from '../lib/inscricao'
import InscricaoForm from '../components/InscricaoForm.vue'

export default {
  name: 'InscricaoPage',
  components: { InscricaoForm },
  data() {
    return {
      state: 'loading',
      status: null,
      submitting: false,
      serverError: ''
    }
  },
  computed: {
    fechaEmFormatado() {
      if (!this.status?.fechaEm) return null
      try {
        return new Date(this.status.fechaEm).toLocaleString('pt-BR', {
          day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
        })
      } catch { return null }
    }
  },
  mounted() {
    this.loadStatus()
  },
  methods: {
    async loadStatus() {
      try {
        const info = await getInscricaoInfo()
        this.status = info
        this.state = info.aberta ? 'editing' : 'fechada'
      } catch (err) {
        // Em erro de rede, tenta deixar aberto pra nao bloquear cadastro
        this.status = { aberta: true, fechaEm: null }
        this.state = 'editing'
      }
    },
    async onSubmit(payload) {
      this.submitting = true
      this.serverError = ''
      try {
        await submitInscricao(payload)
        this.state = 'success'
      } catch (err) {
        const status = err.response?.status
        const data = err.response?.data
        if (status === 410) {
          this.status = {
            aberta: false,
            fechaEm: data?.fechaEm || null,
            mensagem: data?.message || 'Inscricoes encerradas.'
          }
          this.state = 'fechada'
        } else if (status === 429) {
          this.serverError = data?.message || 'Muitas tentativas. Aguarde 1 minuto.'
        } else if (status === 400 && data?.errors) {
          this.serverError = data.errors.map(e => e.message).join(' ')
        } else {
          this.serverError = data?.message || 'Erro ao registrar inscricao. Tente novamente.'
        }
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.inscricao-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: var(--spacing-lg) var(--spacing-base);
  background: linear-gradient(180deg, #eaeaea 0%, #f5f5f5 100%);
}
.inscricao-card {
  width: 100%;
  max-width: 560px;
  padding: var(--spacing-lg);
  margin-top: var(--spacing-base);
}
.inscricao-header {
  text-align: center;
  margin-bottom: var(--spacing-lg);
}
.brand {
  width: 64px;
  height: 64px;
  border-radius: var(--radius-circle);
  object-fit: cover;
  margin-bottom: var(--spacing-md);
}
.inscricao-header h1 {
  font-size: var(--text-xl);
  font-weight: 700;
  color: var(--color-text-primary);
  margin: 0 0 var(--spacing-sm);
}
.subtitle {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
}
.state-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--spacing-md);
  padding: var(--spacing-lg) 0;
}
.state-icon {
  font-size: 64px;
  line-height: 1;
}
.state-icon.success { color: var(--color-success); }
.state-title {
  font-size: var(--text-lg);
  font-weight: 700;
  color: var(--color-text-primary);
}
.state-msg {
  font-size: var(--text-base);
  color: var(--color-text-secondary);
  max-width: 380px;
}
.state-date {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
}
.contato-hint {
  font-size: var(--text-xs);
  color: var(--color-text-muted);
  margin-top: var(--spacing-md);
}
.back-btn { margin-top: var(--spacing-md); }
.inscricao-footer {
  margin-top: var(--spacing-lg);
  color: var(--color-text-muted);
}
.loader {
  width: 28px;
  height: 28px;
  border: 3px solid var(--color-bg-separator);
  border-top-color: var(--color-accent);
  border-radius: var(--radius-circle);
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>
